export default {"src":"/_next/static/media/backyard.e03e658f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};